import { RouteRecordRaw } from 'vue-router'
import { RolesMap } from '@/models/user'
import WorkOrderModule from './WorkOrderModule.vue'
import ListWorkOrders from './views/ListWorkOrders.vue'
import CreateWorkOrder from './views/CreateWorkOrder.vue'
import ShowWorkOrder from './views/ShowWorkOrder.vue'
import EditWorkOrder from './views/EditWorkOrder.vue'
import ViewWorkOrder from './views/ViewWorkOrder.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/workOrders',
    component: WorkOrderModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListWorkOrders',
        component: ListWorkOrders,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateWorkOrder',
        component: CreateWorkOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowWorkOrder',
        component: ShowWorkOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'edit/:id',
        name: 'EditWorkOrder',
        component: EditWorkOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  },
  {
    path: '/workOrder/:id',
    name: 'ViewWorkOrder',
    component: ViewWorkOrder
  }
]

export default routes
